module.exports = __webpack_public_path__ + "static/media/innowind-forestheight-bannerimg.6fadb637.jpg";